import { render, staticRenderFns } from "./detail-partner.vue?vue&type=template&id=d5b8eecc"
import script from "./detail-partner.vue?vue&type=script&lang=js"
export * from "./detail-partner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports